import React from "react";
import GenericPage from "../components/pages/GenericPage";
import { graphql } from "gatsby";
import SEO from "../components/seo";
import Impact from "../components/impact/universalTracking";
export default function pageTemplate({ data }) {
  return (
    <>
      <Impact />
      <SEO title={data.datoCmsPage.title} description={data.datoCmsPage.description} />
      <GenericPage data={data} />
    </>
  );
}

export const query = graphql`
  query pageDataQuery($slug: String!, $locale: String!) {
    datoCmsPage(slug: { eq: $slug }, locale: { eq: $locale }) {
      id
      title
      description
      slug
      customClass
      pageContent {
        ...CollectionProductsListComponent
        ...ImageCardComponent
        ...LeftImageTextComponent
        ...RightImageTextComponent
        ...HeroComponent
        ...CopyComponent
        ...FullWidthImageComponent
        ...EmployeeCardComponent
        ...HubspotFormComponent
      }
    }
  }
`;
